import { render, staticRenderFns } from "./BulbTags.vue?vue&type=template&id=96d01a8e&scoped=true"
import script from "./BulbTags.vue?vue&type=script&lang=js"
export * from "./BulbTags.vue?vue&type=script&lang=js"
import style0 from "./BulbTags.vue?vue&type=style&index=0&id=96d01a8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96d01a8e",
  null
  
)

export default component.exports